export enum ColorEnum {
    GREEN = 0,
    RED = 1,
    YELLOW = 2,
    BLUE = 3,
    GRAY = 4
}